class MaritimeObject {
    id = null;
    active = true;
    maritime_object_type_id = 1;
    name = '';
    vessel_id = null;
    maritime_object_owner_id = null;
    maritime_object_manager_id = null;
    client_id = null;
    invoice_to_id = null;
    employer_id = null;
    email = '';
    details = '';
    notes = '';
    internal_office_employer_id = null;
    contract_header = '';

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default MaritimeObject;
